<template>
  <div class="Avos mb-2">
    <div class="Avos_header mb-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="Avos_header_title">
            Avós
          </h2>
        </div>
        <div class="d-inline-block">
          <button class="btn btn-sm btn-primary"
                  type="button"
                  :disabled="!genitores.length"
                  @click="addNewAvo">
            Adicionar
          </button>
        </div>
      </div>
    </div>

    <div class="Avos_body">
      <form v-if="avos.length"
            class="px-2 mt-2"
            novalidate>
        <div v-for="(avo, indexes) in avos"
             :key="indexes"
             class="row">
          <div class="col-sm-5 col-md-5">
            <div class="form-group">
              <label :for="`cpf-${_uid}`"
                     class="label">
                Nome Completo
              </label>
              <input :id="`nome-${_uid}`"
                     v-model="avo.nome"
                     v-validate="{ required: avo.filiacao >= 0}"
                     type="text"
                     class="form-control form-control-sm"
                     :name="`nome-${indexes}`"
                     :class="{ 'is-invalid': errors.first(`nome-${indexes}`) }"
                     @change="validateInputs(`nome-${indexes}`, avo)">
              <small v-if="errors.has(`nome-${indexes}`)"
                     class="invalid-feedback">{{ errors.first(`nome-${indexes}`) }}</small>
            </div>
          </div>

          <div class="col-sm-6 col-md-6">
            <label :for="`filiacao-${_uid}`"
                   class="label">
              Filiado a:
            </label>
            <div class="row">
              <div v-for="(genitor, index) in genitores"
                   :key="index"
                   class="col">
                <b-form-radio :id="`filiacao-${_uid}-${indexes}-${index}`"
                              v-model="avo.filiacao"
                              v-validate="{required : !!avo.nome}"
                              :name="`some-radios-${indexes}`"
                              :value="index"
                              :class="{ 'is-invalid': errors.first(`some-radios-${indexes}`) }"
                              @change="validateInputs(`some-radios-${indexes}`, avo, genitor.genitor_id)">
                  {{ genitor.pessoa.nome }}
                </b-form-radio>
              </div>
            </div>
          </div>
          <div class="div-btn-excluir col-sm-1 col-md-1">
            <button class="btn btn-danger"
                    type="button"
                    @click="deleteAvo(avo)">
              <IconSvg class="ExcluirAvo-icon icon--sm"
                       icon="trash" />
            </button>
          </div>
          <hr class="hr-avo">
        </div>
      </form>
      <div v-if="!avos.length"
           class="px-2 pt-2">
        <p class="text-muted">
          Sem Avós Cadastrados
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Avos',
    props: {
      propGenitores: {type: Array, default: () => [] },
    },
    data () {
      return {
        genitores: [],
        filiacoes: [],
        avos: []
      }
    },
    watch: {
      propGenitores () {
        this.init()
        if (!this.avos.length && this.filiacoes[0]) {
          let newAvos = []
          this.filiacoes.forEach((avos, index) => {
            if (!avos) return

            avos.forEach((avo) => {
              avo.filiacao = index
              newAvos.push(avo)
            })
          })
          this.avos = newAvos
        }

        if (!this.propGenitores.length) this.avos = []
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.genitores = this.propGenitores
        this.filiacoes = this.genitores.map(res => res.filiacao)
      },
      addNewAvo () {
        this.avos.push({})
      },
      validateInputs (name, avo, genitor_id = null) {
        setTimeout(() => {
          this.$validator.validate(name).then(resp => {
            if (resp) {
              this.changed(avo, genitor_id)
            }
          }, 100)
        })
      },

      changed (avoForm, genitor_id) {
        if (!avoForm.nome || avoForm.filiacao == null) return

        this.filiacoes = this.filiacoes.map((filiacao, index) => {
          filiacao = this.avos.filter(avo => !!avo.nome && avo.filiacao == index)

          filiacao.map(res => this.updateAvo(res, genitor_id))

          return filiacao
        })

        this.genitores = this.genitores.map((genitor, index) => {
          genitor.filiacao = this.filiacoes[index]

          return genitor
        })
        this.$emit('changed', this.genitores)
      },

      updateAvo (avo, genitor_id) {
        if (avo.avo_id) {
          avo.genitor_id = genitor_id
          this.$emit('updateAvo', avo)
        }
      },
      deleteAvo (avo) {
        if (avo.avo_id) {
          objSwal.question.title = 'Excluir avo'
          objSwal.question.text = 'Tem certeza que deseja excluir esse avo?'
          return Swal.fire(objSwal.question).then(res => {
            if (res.value) {
              this.avos.splice(this.avos.indexOf(avo), 1)
              this.$emit('deleteAvo', avo.avo_id)
            }
          })
        } else {
          this.avos.splice(this.avos.indexOf(avo), 1)
          this.changed(avo)
        }
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .Avos {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }

  .div-btn-excluir {
    display: flex;
    align-items: center ;
  }

  .ExcluirAvo {
      &-icon, svg {
        fill: white;
        width: 10px;
      }
  }

  .hr-avo {
    border-top: 1px solid #ddd;
    width: 97%;
  }
</style>
